export default __webpack_public_path__ + "static/media/prodvsdisp2.47d335c5.jpg";